import React, { createContext, useReducer, useContext } from 'react';


const selectedProfile = JSON.parse(sessionStorage.getItem('bigbasketProfile'))

// Initial state for the context
const initialState = {
  selectedBigbasketProfile: {
    ...( selectedProfile ? { ...selectedProfile } : {} )
  },
  bigbasketProfiles: [],
};

// Define the reducer function
const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_SELECTED_BIGBASKET_PROFILE':
      return { ...state, selectedBigbasketProfile: action.payload };
    case 'UPDATE_BIGBASKET_PROFILES':
        return { ...state, bigbasketProfiles: action.payload };
        default:
      return state;
  }
};

// Create the context
const BigbasketContext = createContext();

// Create a custom hook to use the context
const useBigbasketContext = () => {
  const context = useContext(BigbasketContext);
  if (!context) {
    throw new Error('useBigbasketContext must be used within a BigbasketProvider');
  }
  return context;
};

// Create the provider component
const BigbasketProvider = ({ children }) => {
  const [bigbasketState, bigbasketDispatch] = useReducer(reducer, initialState);

  return (
    <BigbasketContext.Provider value={{ bigbasketState, bigbasketDispatch }}>
      {children}
    </BigbasketContext.Provider>
  );
};

export { BigbasketProvider, useBigbasketContext };